<template>
  <div class="manage-fonts">
    <b-button
      v-if="previousFontSize"
      class="manage-fonts__decrease"
      data-test="decrease-button"
      size="xs"
      variant="outline-light"
      @click="decreaseFont"
    >
      {{ $t('login.decrease-font-size') }}
    </b-button>
    <b-button
      v-if="nextFontSize"
      class="manage-fonts__increase"
      data-test="increase-button"
      size="xs"
      variant="outline-light"
      @click="increaseFont"
    >
      {{ $t('login.increase-font-size') }}
    </b-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions([
      'increaseFont',
      'decreaseFont',
    ]),
  },
  computed: {
    ...mapGetters([
      'nextFontSize',
      'previousFontSize',
    ]),
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.manage-fonts
  display: flex
  &__increase:not(:only-child)
    margin-left: 10px

  +media-min-sm()
  +media-min-md()
  +media-min-lg()
</style>
